// extracted by mini-css-extract-plugin
export default {"smTd":"WithdrawalRequests_smTd__CYDf+","priceTd":"WithdrawalRequests_priceTd__3WteH","filterInput":"WithdrawalRequests_filterInput__65bPT"};